<div class="main-container" style="margin: auto">
    <div class="row page-header-actions">
    </div>

    <div class="page-content">
        <h1 class="mat-section-title">Flujo de Crédito Light</h1>
        <label class="mat-sub-title mb-5" for="">Selección de modelo</label>

        <div class="row justify-content-center" [formGroup]="modelForm">
            <div class="col-7">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Seleccione el modelo actual</mat-label>
                    <mat-select formControlName="model">
                        <mat-option *ngFor="let model of models" [value]="model">
                            {{ model | titlecase }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-1">
                <mat-spinner *ngIf="isLoadingModels" [diameter]="30" class="mt-3"></mat-spinner>
            </div>
        </div>
    </div>
</div>